module.exports = __webpack_public_path__ + "media/images/close-0286ed6b4209dd095a8125dd2b8655ad.svg";